// @mui material components
import React from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Presentation page sections
import InformationHome from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/InformationHome";
import TestimonialsHome from "pages/Homepage/sections/TestimonialsHome";
import HeroSection from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/HeroSection";
import ArticleContent from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/ArticleContent";
import ServiceImageGallery from "components/ServiceImageGallery";
import officeHero from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/images/hero17.webp";
import officeFront from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/images/bgFront15.webp";
import officeBack from "pages/Servicii/ServiciiSpeciale/CuratenieBirouriSedii/sections/sections/images/bgBack15.webp";

const officeGallery = [
    { src: officeHero, alt: "Curățenie profesională într-un spațiu de birouri" },
    { src: officeFront, alt: "Întreținerea zilnică a unui sediu de companie" },
    { src: officeBack, alt: "Echipamente și operațiuni de curățenie pentru birouri" },
];

function CuratenieBirouriSedii() {
    return (
        <>
            <Helmet>
                <title>Curățenie Birouri, Firme și Spații Comerciale | Doral Cleaning</title>
                <meta
                    name="description"
                    content="Servicii de curățenie pentru birouri, firme și spații comerciale: întreținere zilnică sau periodică, echipă instruită și control al calității."
                />
                <link
                    rel="canonical"
                    href="https://doral-cleaning.ro/curatenie-birouri-firme-spatii-comerciale/"
                />
                <script type="application/ld+json">
                    {`
                    {
                    "@context": "https://schema.org",
                    "@type": "FAQPage",
                    "mainEntity": [
                    {
                    "@type": "Question",
                    "name": "Cum procedați în cazul echipamentelor electronice sensibile, precum monitoarele sau serverele?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Personalul nostru este instruit să intervină cu maximă discreție și respect pentru tehnologia dumneavoastră. Folosim exclusiv lavete speciale din microfibră antistatică și soluții profesionale care nu lasă reziduuri. Curățăm ecranele și perifericele fără a le umezi excesiv sau a le deteriora, evitând complet orice risc de scurtcircuit sau defecțiune tehnică."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Există riscul ca praful ridicat în timpul curățeniei să provoace alergii angajaților?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Absolut nu. Utilizăm aspiratoare industriale dotate cu filtre hepa performante, capabile să capteze 99,97% din particulele fine de praf și alergeni. Acest sistem nu permite redistribuirea prafului în aerul respirabil. În plus, folosim produse de curățare hipoalergenice, asigurând un aer curat și un mediu sănătos chiar și pentru persoanele cu sensibilități respiratorii ridicate."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Ce se întâmplă dacă un obiect de valoare din birou este deteriorat accidental?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Serviciile noastre sunt garantate și asigurate printr-o poliță de asigurare de răspundere civilă profesională. Deși lucrăm cu o atenție sporită pentru a preveni orice incident, în cazul rar al unei deteriorări accidentale, asigurarea noastră acoperă integral costurile daunelor. Acest lucru vă oferă liniștea deplină că bunurile firmei dumneavoastră sunt protejate juridic și financiar în orice moment al intervenției noastre."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Cât de des recomandați curățenia generală în spațiile comerciale sau firme?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Pentru a păstra un aspect impecabil, recomandăm curățenia de întreținere zilnică sau de cel puțin trei ori pe săptămână, în funcție de numărul de persoane prezente în sediu. Această rutină trebuie completată de o curățenie generală detaliată realizată o dată la trei luni. În spațiile comerciale cu trafic pietonal intens, frecvența intervențiilor poate fi mai mare pentru a asigura standardele de igienă necesare."
                    }
                    },
                    {
                    "@type": "Question",
                    "name": "Putem solicita servicii suplimentare în afara abonamentului, cum ar fi spălarea geamurilor la înălțime?",
                    "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Desigur. Flexibilitatea operațională este unul dintre punctele noastre forte. Puteți solicita oricând intervenții speciale care nu sunt incluse în abonamentul de bază, precum spălarea suprafețelor vitrate exterioare, igienizarea în profunzime a tapițeriilor sau tratamente speciale pentru pardoseli de piatră. Toate aceste solicitări sunt integrate rapid în programul agreat pentru a nu perturba activitatea firmei."
                    }
                    }
                    ]
                    }
                    `}
                </script>
                <script type="application/ld+json">
                    {`
                    {
                      "@context": "https://schema.org",
                      "@type": "LocalBusiness",
                      "name": "Doral Cleaning - Servicii profesionale de curatenie",
                      "image": "",
                      "@id": "",
                      "url": "",
                      "telephone": "0730 407 322",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "Calea Șerban Vodă 82, Sector 4, 040213 București",
                        "addressLocality": "",
                        "postalCode": "",
                        "addressCountry": ""
                      },
                      "geo": {
                        "@type": "GeoCoordinates",
                        "latitude": 44.4202372718721,
                        "longitude": 26.10209372955662
                      }  
                    }
                    `}
                </script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    zIndex: 1,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <TestimonialsHome />
                <InformationHome />
                <ArticleContent />
                <ServiceImageGallery
                    images={officeGallery}
                    title="Galerie curățenie birouri și sedii"
                />
            </Card>
        </>
    );
}

export default CuratenieBirouriSedii;
